import { StyledOrangeGradText, StyledText } from '@/shared/styles';
import { StyledFixIssuesBanner } from './AccessibilityScore.styles';
import { DemoModal } from '@/Views/BeforeLogin/LandingPages/Common/DemoModal/DemoModal';
import { useTranslation } from 'react-i18next';

export const FixIssuesBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StyledFixIssuesBanner>
      <StyledText fontSize="18px" fontWeight={600}>
        {t('free_tools.accessibility_checker.fix_issues')}{' '}
        <StyledOrangeGradText fontSize="18px" fontWeight={600} lineHeight="1">
          {t('free_tools.accessibility_checker.u1_toolkit')}
        </StyledOrangeGradText>{' '}
        {t('free_tools.accessibility_checker.seamless_debugging')}
      </StyledText>
      <DemoModal $btnText={t('free_tools.accessibility_checker.try_now')} $btnWidth="fit-content" />
    </StyledFixIssuesBanner>
  );
};
